import { PayloadAction } from '@reduxjs/toolkit'
import { Company, CompanySliceState } from 'src/core/models'
import { initialState } from './state'

const reducers = {
  /* Company Details Reducers */
  setCompanyDetailsLoading: (state: CompanySliceState, action: PayloadAction<boolean>) => {
    state.companyDetails.loading = action.payload
  },
  setCompanyDetailsData: (state: CompanySliceState, action: PayloadAction<Company>) => {
    state.companyDetails.data = action.payload
  },
  resetCompanyDetailState: (state: CompanySliceState) => {
    state.companyDetails = initialState.companyDetails
  },
  /* Edit Company Details Reducers */
  setEditCompanyLoading: (state: CompanySliceState, action: PayloadAction<boolean>) => {
    state.editCompany.loading = action.payload
  },
  setEditCompanySuccess: (state: CompanySliceState, action: PayloadAction<boolean>) => {
    state.editCompany.success = action.payload
  },
  setEditCompanyError: (state: CompanySliceState, action: PayloadAction<any>) => {
    state.editCompany.error = action.payload
  },
  resetEditCompanyState: (state: CompanySliceState) => {
    state.editCompany = initialState.editCompany
  },
}

export default reducers
